/**
 * == Controller: ReportsController
 *
 * Lightweight filter coordinator for report views. Extends the platform base
 * controller to persist selected projects and fetch updated reporting
 * parameters through Turbo streams.
 *
 * === Responsibilities:
 * - Re-enable disabled submit buttons once Turbo connects.
 * - Remember the selected project in cookies for subsequent visits.
 * - Trigger background fetches when the project dropdown changes.
 */
import PlatformBaseController from "./platform_base_controller"

// Main controller for handling project/document list filtering
export default class extends PlatformBaseController {

    static targets = [];

    static values = {}

    connect() {
        if (this.hasFilterSubmitTarget) {
            this.filterSubmitTarget.disabled = false;
        }
    }

    // Handles project select dropdown changes
    selectProject(event) {
        const projectId = event.target.value;
        this.setPersistentFilter("project_id", projectId);
        this.fetchAction(`/insights/filter_parameters?project_id=${encodeURIComponent(projectId)}`);
    }
}
